export const environment = {
  production: false,
  BASE_URL: "http://localhost:4000/api/",
  // BASE_URL: "https://elaw-backend-development.azurewebsites.net/api/",
};
